const state = {
    user: {},
    token: {},
    projectsScope: {}
}

export default state
